import { SideNavigationLink } from "../../../components/SideNavigation";

export const CompanyCompetenciesNavigationLinks: SideNavigationLink[] = [
	{
		label: "All Competencies",
		href: "/company/competencies/all/",
		key: "all",
	},
];
